export const POST_CREATE_PRODUCT_REQUEST = "POST_CREATE_PRODUCT_REQUEST";
export const POST_CREATE_PRODUCT_ERROR = "POST_CREATE_PRODUCT_ERROR";
export const POST_CREATE_PRODUCT_SUCCESS = "POST_CREATE_PRODUCT_SUCCESS";
